import React from "react";
import { Link } from "react-router-dom";
import "./HomeFooter.css";

function HomeFooter() {
  return (
    <div className="wrapper-footer" style={{ backgroundColor: "#fafafa" }}>
      <div
        style={{
          width: 1024,
          paddingTop: 50,
          paddingBottom: 50,
        }}
      >
        <div style={{ fontSize: 12 }}>
          <p style={{ margin: 0, marginTop: 6 }}>주식회사 본디</p>
          <p style={{ margin: 0, marginTop: 6 }}>대표: 박상빈</p>
          <p style={{ margin: 0, marginTop: 6 }}>사업자번호: </p>
          <p style={{ margin: 0, marginTop: 6 }}>통신판매업 신고번호: </p>
          <p style={{ margin: 0, marginTop: 6 }}>
            경기도 안산시 상록구 초당로 49
          </p>
          <p style={{ margin: 0, marginTop: 6 }}>연락처: 010-3013-0317</p>
          <p style={{ margin: 0, marginTop: 6 }}>
            CopyRight by Bondi All rights reserved
          </p>
          <div style={{ display: "flex" }}>
            <Link to="/policy/service" style={{ textDecoration: "none" }}>
              <p style={{ color: "black", fontWeight: "600" }}>이용약관</p>
            </Link>
            <Link
              to="/policy/privacy"
              style={{ textDecoration: "none", marginLeft: 20 }}
            >
              <p style={{ color: "black", fontWeight: "600" }}>
                개인정보 처리방침
              </p>
            </Link>
            <Link
              to="/policy/location"
              style={{ textDecoration: "none", marginLeft: 20 }}
            >
              <p style={{ color: "black", fontWeight: "600" }}>위치정보 약관</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeFooter;
